<template>
    <div class="row m-0">
        <div class="col-12">
            <div class="row headers text-dark text-center py-3">
                <h4 class="m-0 mx-auto"> {{ $t("skills") }} </h4>
            </div>
            <div class="row">
                <div class="sections py-3 px-3 w-100 text-left">
                    <div id="chartdiv" class="en-inputs w-100 ltr"></div>
                    <div class="en-inputs">
                        <span class="text-justify"> <small> <b> Genetics </b> <span class="font-weight-light"> : Medical/Human Genetics </span> </small> </span>
                    </div>
                    <div class="text-center">
                        <vs-button class="d-inline mt-3" transparent active color="dark" data-toggle="collapse"
                                   data-target="#collapseSkills" aria-expanded="false" aria-controls="collapseSkills">
                            {{ $t("more") }}
                        </vs-button>
                    </div>
                    <div class="collapse" id="collapseSkills">
                        <span class="pt-2 d-table"> {{ $t("try") }}: </span>
                        <div id="chord-chart" class="en-inputs w-100 ltr"></div>
                        <div id="tech-chart" class="en-inputs w-100 ltr"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        name: "Skills",
        data() {
            return {

            }
        },
        mounted() {
            am4core.useTheme(am4themes_animated);

            let chart = am4core.create("chartdiv", am4charts.XYChart);
            chart.logo.disabled = true;
            chart.hiddenState.properties.opacity = 0;
            chart.logo.height = -300;
            chart.paddingRight = 40;

            chart.data = [{
                "name": "Biochemistry",
                "steps": 40
            }, {
                "name": "Hematology",
                "steps": 60
            }, {
                "name": "Immunology",
                "steps": 60
            },  {
                "name": "Bioinformatics",
                "steps": 80
            }, {
                "name": "Genetics",
                "steps": 80
            }];

            let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "name";
            categoryAxis.renderer.grid.template.strokeOpacity = 0;
            categoryAxis.renderer.minGridDistance = 10;
            categoryAxis.renderer.labels.template.dx = -20;
            categoryAxis.renderer.minWidth = 120;
            categoryAxis.renderer.tooltip.dx = -20;

            let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
            valueAxis.renderer.inside = false;
            valueAxis.renderer.grid.template.strokeOpacity = 0;
            valueAxis.min = 0;
            valueAxis.max = 100;
            valueAxis.cursorTooltipEnabled = false;
            valueAxis.renderer.baseGrid.strokeOpacity = 0;
            valueAxis.renderer.labels.template.dy = 0;

            let series = chart.series.push(new am4charts.ColumnSeries);
            series.dataFields.valueX = "steps";
            series.dataFields.categoryY = "name";
            series.tooltipText = "{valueX.value}";
            series.tooltip.pointerOrientation = "vertical";
            series.tooltip.dy = -10;
            series.columnsContainer.zIndex = 100;

            let columnTemplate = series.columns.template;
            columnTemplate.height = am4core.percent(20);
            columnTemplate.maxHeight = 20;
            columnTemplate.column.cornerRadius(60, 10, 60, 10);
            columnTemplate.strokeOpacity = 0;

            series.heatRules.push({ target: columnTemplate, property: "fill", dataField: "valueX", min: am4core.color("#d8d5d5"), max: am4core.color("#7a7979") });
            series.mainContainer.mask = undefined;

            let cursor = new am4charts.XYCursor();
            chart.cursor = cursor;
            cursor.lineX.disabled = true;
            cursor.lineY.disabled = true;
            cursor.behavior = "none";

            let bullet = columnTemplate.createChild(am4charts.CircleBullet);
            bullet.circle.radius = 15;
            bullet.valign = "middle";
            bullet.align = "left";
            bullet.isMeasured = true;
            bullet.interactionsEnabled = false;
            bullet.horizontalCenter = "right";
            bullet.interactionsEnabled = false;

            let image = bullet.createChild(am4core.Image);
            image.width = 25;
            image.horizontalCenter = "middle";
            image.verticalCenter = "middle";
            image.propertyFields.href = "href";

            image.adapter.add("mask", function (mask, target) {
                let circleBullet = target.parent;
                return circleBullet.circle;
            });

            let chart1 = am4core.create("chord-chart", am4charts.ChordDiagram);
            chart1.logo.disabled = true;

            chart1.data = [
                { from: "Cancer Research", to: "Bioinformatics", value: 10 },
                { from: "Bioinformatics", to: "Neuroscience", value: 6 },
                { from: "Neuroscience", to: "Cancer Research", value: 4 }
            ];

            chart1.dataFields.fromName = "from";
            chart1.dataFields.toName = "to";
            chart1.dataFields.value = "value";

            let nodeTemplate = chart1.nodes.template;
            nodeTemplate.readerTitle = "Click to show/hide or drag to rearrange";
            nodeTemplate.showSystemTooltip = true;

            let nodeLink = chart1.links.template;
            bullet = nodeLink.bullets.push(new am4charts.CircleBullet());
            bullet.fillOpacity = 1;
            bullet.circle.radius = 5;
            bullet.locationX = 0.5;

            chart1.events.on("ready", function() {
                for (let i = 0; i < chart1.links.length; i++) {
                    let link = chart1.links.getIndex(i);
                    let bullet = link.bullets.getIndex(0);

                    animateBullet(bullet);
                }
            });

            function animateBullet(bullet) {
                let duration = 3000 * Math.random() + 2000;
                let animation = bullet.animate([{ property: "locationX", from: 0, to: 1 }], duration)
                animation.events.on("animationended", function(event) {
                    animateBullet(event.target.object);
                })
            }

            let chart2 = am4core.create("tech-chart", am4plugins_forceDirected.ForceDirectedTree);
            chart2.logo.disabled = true;

            let networkSeries = chart2.series.push(new am4plugins_forceDirected.ForceDirectedSeries());
            networkSeries.dataFields.linkWith = "linkWith";
            networkSeries.dataFields.name = "name";
            networkSeries.dataFields.id = "name";
            networkSeries.dataFields.value = "value";
            networkSeries.dataFields.children = "children";

            networkSeries.nodes.template.label.text = "{name}";
            networkSeries.fontSize = 12;
            networkSeries.linkWithStrength = 0;

            nodeTemplate = networkSeries.nodes.template;
            nodeTemplate.tooltipText = "{name}";
            nodeTemplate.fillOpacity = 1;
            nodeTemplate.label.hideOversized = true;
            nodeTemplate.label.truncate = true;

            let linkTemplate = networkSeries.links.template;
            linkTemplate.strokeWidth = 2;
            let linkHoverState = linkTemplate.states.create("hover");
            linkHoverState.properties.strokeOpacity = 1;
            linkHoverState.properties.strokeWidth = 2;

            nodeTemplate.events.on("over", function (event) {
                let dataItem = event.target.dataItem;
                dataItem.childLinks.each(function (link) {
                    link.isHover = true;
                })
            });

            nodeTemplate.events.on("out", function (event) {
                let dataItem = event.target.dataItem;
                dataItem.childLinks.each(function (link) {
                    link.isHover = false;
                })
            });

            networkSeries.data = [
                {
                    "name": "Cancer Research",
                    "value": 250,
                    "children": [
                        {
                            "name": "Early Diagnosis",
                            "value": 200
                        },
                        {
                            "name": "Prognosis",
                            "value": 200
                        },
                        {
                            "name": "Treatment",
                            "value": 200
                        },
                        {
                            "name": "Biomarker",
                            "value": 200
                        }
                    ]
                },
                {
                    "name": "Bioinformatics",
                    "value": 250,
                    "linkWith": [],
                    "children": [
                        {
                            "name": "In Silico Study",
                            "value": 200
                        },
                        {
                            "name": "Computational Biology",
                            "value": 200
                        },
                        {
                            "name": "Predictive Model",
                            "value": 200
                        },
                        {
                            "name": "R  Programming",
                            "value": 200
                        }
                    ]
                },
                {
                    "name": "Neuroscience",
                    "value": 250,
                    "linkWith": [],
                    "children": [
                        {
                            "name": "Complication Prevention",
                            "value": 200
                        },
                        {
                            "name": "Better Management",
                            "value": 200
                        }
                    ]
                }
            ];
        },
        methods : {

        }
    }
</script>

<style>

</style>

<style scoped>
    #chartdiv {
        height: 300px;
    }

    #chord-chart {
        height: 350px;
    }

    #tech-chart {
        height: 350px;
    }
</style>
